export const dynamicQueryMethods = ['updateRow', 'deleteRow', 'load', 'startLoad', 'stopLoad'] as const;

export type DynamicQueryMethod = typeof dynamicQueryMethods[number];

export function isDynamicQueryMethod(method: any): method is DynamicQueryMethod {
  return dynamicQueryMethods.includes(method);
}
